export enum DateFilterType {
    CLOSING,
    DAY,
    WEEK,
    MONTH,
    YEAR,
    CUSTOM,
}

export interface DateHistoryData {
    name: string;
    startDate: Date;
    endDate: Date;
    isCustom?: boolean;
}
